import React from 'react';

const LABELS = {
  REGULAR: 'Market Open',
  PRE: 'Pre-Market',
  PREPRE: 'Pre-Market',
  POST: 'After-Hours',
  POSTPOST: 'After-Hours',
  CLOSED: 'Market Closed',
};

export default function MarketStatusBadge({ marketState }) {
  const label = LABELS[marketState] || 'Status Unknown';
  const tone = marketState === 'REGULAR' ? 'live' : marketState === 'CLOSED' || !marketState ? 'off' : 'paper';
  return (
    <span className={`status-pill-link ${tone}`}>
      <span className="status-dot" />
      {label}
    </span>
  );
}
